<div class="top-menu">
    <p-button label="Add" (onClick)="addForm()"></p-button>
    <span>Total: {{totalAmount}}</span>
    <div class="submit-button-container">
        <p-button (onClick)="submitForm()" label="Submit"></p-button>
    </div>
</div>
<div [formGroup]="rootForm">
    <div>
        <span>Date: </span>
        <p-calendar formControlName="date"></p-calendar>
    </div>
    <div formArrayName="items">
        <div *ngFor="let form of bookingFormArray.controls; let i = index" [formGroupName]="i">
            <p-dropdown [options]="bookingIdItems" [filter]="true" filterBy="label" optionLabel="label" formControlName="bookingId" placeholder="select"></p-dropdown>
            <input pInputText formControlName="amount" (blur)="amountChange()">
            <p-button icon="pi pi-trash" label="delete" (onClick)="deleteBookingForm(i)" styleClass="p-button-danger"></p-button>
        </div>
    </div>
</div>
